import { StackProps } from "@chakra-ui/react"

const base: StackProps = {
  w: "100%",
  p: 4,
  borderRadius: "xl"
}

export const transient: StackProps = {
  ...base,
  bg: "whiteAlpha.500"
}

export const solid: StackProps = {
  ...base,
  bg: "blackAlpha.500"
}
